import { KeyLinkIcon } from './KeyLinkIcon';

/**
 * author: Haley Halcyon
 * id 08C0F709-4E1C-4BFD-8CC6-BC12FE5CDD9B
 * name key-link
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/key-link.svg
 * tags
 */
export const ForeignKeyIcon = KeyLinkIcon;
export default ForeignKeyIcon